module.exports = __webpack_public_path__ + "static/media/qurm_villas2.10b8d067.webp";